<form [formGroup]="packageTypeForm" (ngSubmit)="save()">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3" *ngIf="!packageType.id">
        <label [for]="'name-' + packageType.id" class="col-sm-5 col-form-label">{{ 'LICENSE.PACKAGE_NAME' | translate }} *</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" [id]="'name-' + packageType.id" formControlName="name">
          <hbo-control-messages [control]="packageTypeForm.get('name')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'private-' + packageType.id" class="col-sm-5 col-form-label">{{ 'LICENSE.PRIVACY' | translate }} *</label>
        <div class="col-sm-7">
          <select [class]="action === 'create' ? 'form-select' : 'form-control-plaintext'" [id]="'private-' + packageType.id" formControlName="private">
            <option value="false">{{ 'LICENSE.PUBLIC' | translate }}</option>
            <option value="true">{{ 'LICENSE.PRIVATE' | translate }}</option>
          </select>
          <hbo-control-messages [control]="packageTypeForm.get('private')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'testDays-' + packageType.id" class="col-sm-5 col-form-label">{{ 'LICENSE.DEFAULT_TEST_DAYS' | translate }} *</label>
        <div class="col-sm-7">
          <input type="number" [class]="action === 'create' ? 'form-control' : 'form-control-plaintext'" [id]="'testDays-' + packageType.id" formControlName="testDays">
          <hbo-control-messages [control]="packageTypeForm.get('testDays')!"></hbo-control-messages>
        </div>
      </div>
    </div>

    <div class="col-6">
      <h4 class="pb-2 mb-3 border-bottom fw-bold">{{ 'LICENSE.APPS_INCLUDED' | translate }}</h4>

      <!-- TODO: añadir al formgroup por cada app -->
      <div class="row-cols-auto" *ngFor="let app of apps; let i = index">
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" [id]="'app-' + packageType.id + '-' + i" (click)="toggleApp(i + 1)" [checked]="appIds.includes(i + 1)" [disabled]="action === 'edit'">
          <label class="form-check-label" [for]="'app-' + packageType.id + '-' + i">
            {{ app }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="action === 'create' && user.profileId !== 2">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="submit" class="btn btn-dark">{{ 'COMMON.SAVE_CHANGES' | translate }}</button>
  </div>
</form>
